import { DeathCancellationAnscNotificationsResidentSubscriptionCrumbs } from 'subscription/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import CancellationDeathNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-death/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const CancellationDeathNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <CancellationDeathNotificationCivilStatusShared
        scope={IdAmbito.Iscrizioni}
        items={DeathCancellationAnscNotificationsResidentSubscriptionCrumbs()}
      />
    </Fragment>
  );
};

CancellationDeathNotificationCivilStatusPage.displayName =
  'Cancellation Death Notification Page component';

export default CancellationDeathNotificationCivilStatusPage;
